var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5H9V10.5H5V9.5ZM5 7H11V8H5V7ZM5 12H7.5V13H5V12Z",
    stroke: "currentColor",
    strokeWidth: 0,
    fill: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3H11V2.5C11 2.23478 10.8946 1.98043 10.7071 1.79289C10.5196 1.60536 10.2652 1.5 10 1.5H6C5.73478 1.5 5.48043 1.60536 5.29289 1.79289C5.10536 1.98043 5 2.23478 5 2.5V3H3.5C3.23478 3 2.98043 3.10536 2.79289 3.29289C2.60536 3.48043 2.5 3.73478 2.5 4V14.5C2.5 14.7652 2.60536 15.0196 2.79289 15.2071C2.98043 15.3946 3.23478 15.5 3.5 15.5H12.5C12.7652 15.5 13.0196 15.3946 13.2071 15.2071C13.3946 15.0196 13.5 14.7652 13.5 14.5V4C13.5 3.73478 13.3946 3.48043 13.2071 3.29289C13.0196 3.10536 12.7652 3 12.5 3ZM6 2.5H10V4.5H6V2.5ZM12.5 14.5H3.5V4H5V5.5H11V4H12.5V14.5Z",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityReport);
export default __webpack_public_path__ + "static/media/activity_report.63afd30604a33654b466cdee1d508ab3.svg";
export { ForwardRef as ReactComponent };